import { Component } from "react";
import Joi from "joi-browser";

class FormComponent extends Component {
  state = {
    data: { email: "", password: "" },
    errors: {},
  };

  validate = () => {
    const errors = {};
    const { data } = this.state;

    const result = Joi.validate(data, this.schema, { abortEarly: false });

    if (!result.error) return null;

    for (let item of result.error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = (e) => {
    const { name, value } = e.currentTarget;
    const obj = { [name]: value };

    const schema = { [name]: this.schema[name] };

    const result = Joi.validate(obj, schema);
    if (!result.error) return null;
    return result.error.details[0].message;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate();

    this.setState({ errors: errors || {} });
    if (errors) return;

    this.doSubmit();
  };

  handleChange = (e) => {
    const data = { ...this.state.data };

    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(e);
    if (errorMessage) errors[e.currentTarget.name] = errorMessage;
    else delete errors[e.currentTarget.name];

    data[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ data, errors });
  };

  handleRouterRoleSelect = async (e) => {
    const data = { ...this.state.data };

    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(e);
    if (errorMessage) errors[e.currentTarget.name] = errorMessage;
    else delete errors[e.currentTarget.name];

    data[e.currentTarget.name] = e.currentTarget.value;
    const role = e.currentTarget.value;
    if (role !== "NAS") {
      data["radiusServerId"] = undefined;
      data["oltGemIndex"] = undefined;
      data["oltVlan"] = undefined;
      this.setState({ radiusServers: [], data, errors });
    }  else {
      const radiusServers = this.state.routers.filter((r) => r.role === "Radius Server");
      this.setState({ data, errors, radiusServers });
    }
  };

  handleToggle = (e) => {
    const data = { ...this.state.data };

    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(e);
    if (errorMessage) errors[e.currentTarget.name] = errorMessage;
    else delete errors[e.currentTarget.name];

    data[e.currentTarget.name] = e.currentTarget.checked;
    this.setState({ data, errors });
  }
}

export default FormComponent;
